/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface MarketingDomainAuditRowData
 */
export interface MarketingDomainAuditRowData {
    /**
     * 
     * @type {string}
     * @memberof MarketingDomainAuditRowData
     */
    domainId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MarketingDomainAuditRowData
     */
    domainName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MarketingDomainAuditRowData
     */
    domainEnabled?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof MarketingDomainAuditRowData
     */
    campaignCount?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketingDomainAuditRowData
     */
    adCount?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof MarketingDomainAuditRowData
     */
    spend?: MoneyOutput;
    /**
     * 
     * @type {MarketingDomainAuditRowDataFinanceScopeEnum}
     * @memberof MarketingDomainAuditRowData
     */
    financeScope?: MarketingDomainAuditRowDataFinanceScopeEnum;
}


/**
 * @export
 */
export const MarketingDomainAuditRowDataFinanceScopeEnum = {
    RawProvider: 'raw_provider'
} as const;
export type MarketingDomainAuditRowDataFinanceScopeEnum = typeof MarketingDomainAuditRowDataFinanceScopeEnum[keyof typeof MarketingDomainAuditRowDataFinanceScopeEnum];


/**
 * Check if a given object implements the MarketingDomainAuditRowData interface.
 */
export function instanceOfMarketingDomainAuditRowData(value: object): value is MarketingDomainAuditRowData {
    return true;
}

export function MarketingDomainAuditRowDataFromJSON(json: any): MarketingDomainAuditRowData {
    return MarketingDomainAuditRowDataFromJSONTyped(json, false);
}

export function MarketingDomainAuditRowDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarketingDomainAuditRowData {
    if (json == null) {
        return json;
    }
    return {
        
        'domainId': json['domainId'] === undefined ? undefined : json['domainId'] === null ? null : json['domainId'],
        'domainName': json['domainName'] == null ? undefined : json['domainName'],
        'domainEnabled': json['domainEnabled'] === undefined ? undefined : json['domainEnabled'] === null ? null : json['domainEnabled'],
        'campaignCount': json['campaignCount'] == null ? undefined : json['campaignCount'],
        'adCount': json['adCount'] == null ? undefined : json['adCount'],
        'spend': json['spend'] == null ? undefined : MoneyOutputFromJSON(json['spend']),
        'financeScope': json['financeScope'] == null ? undefined : json['financeScope'],
    };
}

export function MarketingDomainAuditRowDataToJSON(json: any): MarketingDomainAuditRowData {
    return MarketingDomainAuditRowDataToJSONTyped(json, false);
}

export function MarketingDomainAuditRowDataToJSONTyped(value?: MarketingDomainAuditRowData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'domainId': value['domainId'],
        'domainName': value['domainName'],
        'domainEnabled': value['domainEnabled'],
        'campaignCount': value['campaignCount'],
        'adCount': value['adCount'],
        'spend': MoneyOutputToJSON(value['spend']),
        'financeScope': value['financeScope'],
    };
}

